<div class="units-wrapper">
    <ev-grid-table [gridModel]="displayTemplate">
        <ev-th>
            <ev-td class="spacing-left" area="spacingLeft"></ev-td>

            @for(column of headers; track column.name) {
            @if(column?.isSortable) {
            <ev-td [area]="column.prop" (click)="updateSort(column.prop)" [isSelectable]="true"
                [textAlignment]="column.textAlignment ?? 'left'"
                [selected]="sortConfig().sortOption.prop == column.prop">
                {{column.name.toUpperCase()}}
            </ev-td>
            }
            @else {
            <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                {{column.name.toUpperCase()}}
            </ev-td>
            }
            }
        </ev-th>

        @if (tableData()) {
        @for(rowData of tableData(); track rowData.functionalUnitNumber) {
        <ev-tr class="ev-row" [hasRowContent]="false">
            <ev-td area="spacingLeft" class="spacing-left" header="" column title="">
                <div class="column-data"></div>
            </ev-td>
            <ev-td area="estateType" header="Type" column title="Type">
                <div class="unit-symbol" [class]="lowercase(rowData.estateType)"></div>
            </ev-td>
            <ev-td area="address" header="Adresse" column title="Adresse" (click)="navigate(rowData.unitId)"
                [fontBold]="sortConfig().sortOption.prop == 'address'">
                <div class="column-data address">{{rowData.address.split(',')[0] | defaultconvert: "-"}}</div>
            </ev-td>
            <ev-td area="municipalityName" header="Kommune" column title="Kommune"
                [fontBold]="sortConfig().sortOption.prop == 'municipalityName'">
                <div class="column-data">{{rowData.municipalityName | defaultconvert: "-"}}</div>
            </ev-td>
            <ev-td area="functionalUnitNumber" header="Enhetsnummer" column title="Enhetsnummer"
                [fontBold]="sortConfig().sortOption.prop == 'functionalUnitNumber'">
                <div class="column-data">{{rowData.functionalUnitNumber | defaultconvert: "-"}}</div>
            </ev-td>
            <ev-td area="floor" header="Etg" column title="Etg" [fontBold]="sortConfig().sortOption.prop == 'floor'">
                <div class="column-data">{{rowData.floor | defaultconvert: "-"}}</div>
            </ev-td>
            <ev-td area="primaryArea" header="m2" column title="m2"
                [fontBold]="sortConfig().sortOption.prop == 'primaryArea'">
                <div class="column-data">{{rowData.primaryArea | thousandize | defaultconvert: "-"}}</div>
            </ev-td>
            <ev-td area="nodata" header="Pris eks fg" column title="Pris eks fg"
                [fontBold]="sortConfig().sortOption.prop == 'nodata'">
                <div class="column-data">{{rowData.nodata | thousandize | defaultconvert: "-"}}</div>
            </ev-td>
            <ev-td area="nodata2" header="f.gjeld" column title="f.gjeld"
                [fontBold]="sortConfig().sortOption.prop == 'nodata2'">
                <div class="column-data">{{rowData.nodata2 | thousandize | defaultconvert: "-"}}</div>
            </ev-td>
            <ev-td area="nodata3" header="total" column title="total"
                [fontBold]="sortConfig().sortOption.prop == 'nodata3'">
                <div class="column-data">{{rowData.nodata3 | thousandize | defaultconvert: "-"}}</div>
            </ev-td>
            <ev-td area="nodata4" header="Dato" column title="Dato"
                [fontBold]="sortConfig().sortOption.prop == 'nodata4'">
                <div class="column-data">{{rowData.nodata4 | thousandize | defaultconvert: "-"}}</div>
            </ev-td>
        </ev-tr>
        }}
    </ev-grid-table>

    @if(originalData().length > rowsToShow) {
    <div class="show-more-button">
        <button (click)="onShowMore()">Vis flere</button>
    </div>
    }
</div>